import React from 'react'
import Style from './sectionHeader.module.css'

const SectionHeader = ({ title, subtitle, children }) => (
    <div className={Style.header}>
        <div>
            <h4 className={Style.heading}>{title}</h4>
            {subtitle ? <p className={Style.subheading}>{subtitle}</p> : null}
        </div>
        {children ? <div className={Style.actions}>{children}</div> : null}
    </div>
)

export default SectionHeader
